import React from "react";

import AppHeader from '../components/header/AppHeader';
import PageTitle from '../components/page/PageTitle';
import CardContent from "../components/card/CardContent";
import HomeCard from "../components/home/HomeCard";

import type { HomeCardBlock } from "@/types/Home";

import '../styles/home.scss';

const cardBlock:HomeCardBlock[] = [
    {
        link: '/film-create',
        title: 'ФИЛЬМ',
        description: 'Единичное видео',
        icon: 'https://static.kion.ru/kds/ds/meta_icon/navbar/outline_film.webp'
    },
    {
        link: '/serial/0',
        title: 'Сериал',
        description: 'Многосерийный контент',
        icon: 'https://static.kion.ru/kds/ds/meta_icon/navbar/outline_series.webp'
    }
]

function CreateContent() {
    return (
        <div className="home">
            <AppHeader title="Добавление контента" isLogout={true} />

            <div className="app-container">
                <div className="home__container">
                    <PageTitle title="Выберите тип контента:" />

                    <div className="home__cards">
                        {
                            cardBlock.map((card: HomeCardBlock) => {
                                return (
                                    <CardContent key={card.link} isPaddingTop={true} type="black">
                                        <HomeCard data={card} />
                                    </CardContent>
                                )
                            })
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CreateContent